import React from "react";
import ReduxSignInCard from "./ReduxSignInCard";
import dynamic from "next/dynamic";

interface SignInCardProps {
  onSignIn?: (email: string) => void;
  onAppleSignIn?: () => void;
}

const ReduxProvider = dynamic(() => import('@/store/storeprovider'), {
  ssr: true,
});

const SignInCard: React.FC<SignInCardProps> = (props) => {
  return (
    <ReduxProvider>
      <ReduxSignInCard {...props} />
    </ReduxProvider>
  );
};

export default SignInCard;